<template>
  <b-table
    head-variant="light"
    :empty-text="$t('GERAL.NENHUM_REGISTRO')"
    :fields="fields"
    :items="itens"
    responsive
    show-empty
    striped
    hover
    v-if="podeVisualizar"
    @sort-changed="aoMudarOrdenacao"
  >
    <template #cell(acoes)="item">
      <b-button
        variant="primary"
        v-if="podeVisualizar"
        @click="abrirModalAditivosDoContrato(item.item)"
        >{{ $t('ACADEMICO.VISUALIZAR_ADITIVOS') }}</b-button
      >
    </template>
  </b-table>
</template>

<script>
import Permissoes from '@/components/mixins/permissoes';
import helpers from '@/common/utils/helpers';
export default {
  name: 'TabelaContratosComAditivos',
  mixins: [Permissoes],
  components: {},
  props: {
    itens: { type: Array, default: Array },
  },
  data() {
    return {
      fields: [
        {
          key: 'codigoContrato',
          label: this.$t('ACADEMICO.CODIGO'),
          sortable: true,
        },
        {
          key: 'aluno',
          label: this.$t('GERAL.NOME'),
          sortable: true,
        },
        {
          key: 'tipoContratoDescricao',
          label: this.$t('GERAL.DESCRICAO'),
          sortable: true,
        },
        {
          key: 'statusDescricao',
          label: this.$t('ACADEMICO.STATUS'),
          sortable: true,
        },
        {
          key: 'acoes',
          label: this.$t('GERAL.ACOES'),
        },
      ],
    };
  },
  methods: {
    abrirModalAditivosDoContrato(item) {
      this.$emit('abrirModal', item);
    },
    aoMudarOrdenacao({ sortBy, sortDesc }) {
      let campoOrdenado = helpers.primeiraLetraMaiuscula(sortBy)
      let ordem = sortDesc
      this.$emit('alterar-ordenacao', campoOrdenado, ordem);
    },
  },
};
</script>
